import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { InterfaceElement } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { UXControllerService } from 'src/app/service/controller/ux-controller.service';
import { InterfaceElementTypes } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { DomSanitizer } from '@angular/platform-browser';
import { CosyCommunicationControllerService } from 'src/app/service/controller/cosy-communication-controller.service';
import { AsdBase } from 'src/app/model/asd/asd';
import { CosyFormGroupValidationService } from 'src/app/service/validator/cosy-form-group-validation.service';
import { cloneDeep } from 'lodash-es';

@Component({
  selector: 'app-cosy-wizard',
  templateUrl: './cosy-wizard.component.html',
  styleUrls: ['./cosy-wizard.component.css']
})
export class CosyWizardComponent implements OnInit {
  @Input() ie:InterfaceElement;
  public ieTabs:InterfaceElement[];
  private IE_TYPES = InterfaceElementTypes;
  private pdfURL;
  private pdfBase64;
  private formGroup:FormGroup;
  private RTKeyShowNullable:boolean = false;
  public headline:string = "";
  public activeTab : string = "";
  public currentActiveTab : string = "";
  

  constructor(
    private cosyCommunicationControllerService: CosyCommunicationControllerService,
    public uxControllerService: UXControllerService,
    private cosyFormGroupValidationService: CosyFormGroupValidationService,
    private sanitizor: DomSanitizer
  ) { }

  ngOnInit() {
    if (this.uxControllerService.appStateID == '28370b02-c57e-44d4-999f-01f941fa9ad3') this.headline = this.ie.InterfaceElements.find(element => element.ObjectName == 'DisplayName').Values[0].Value;
    this.tabsAssignment();
  }

  ngDoCheck(){
    if(this.uxControllerService.isDynaFunctionCompleted && this.uxControllerService.dynaReferenceIEID == this.ie.InterfaceElementID && this.ie.InterfaceElements != null){
      this.ieTabs = [];
      this.updateGroupAssignments(this.ie);
      
      for(let iee of this.ie.InterfaceElements){
        if(iee.TypeDID == InterfaceElementTypes.Groups){
          if(iee.InterfaceElements!= null && iee.InterfaceElements.length>0){
            iee.InterfaceElements = iee.InterfaceElements.sort((a,b)=> a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);

            for(let ieee of iee.InterfaceElements){
              if(ieee.InterfaceElements!= null && iee.InterfaceElements.length>0){
                ieee.InterfaceElements = ieee.InterfaceElements.sort((a,b)=> a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);
              }
            }
          }
        } 
      }
      //setTimeout(() => {
      this.tabsAssignment();
      let tabIndex = -1;
      tabIndex = this.ieTabs.map(function(e){ return e.InterfaceElementID}).indexOf(this.currentActiveTab);
      if(this.currentActiveTab!== "" && this.currentActiveTab !== this.activeTab && tabIndex> -1){
        this.activeTab = this.currentActiveTab;
      }
      //}, 100);
    
      this.uxControllerService.isDynaFunctionCompleted = false;
    }
  }
  onNavChange(e){   
    this.currentActiveTab = e['nextId'];
  }
  tabsAssignment(){
    this.ieTabs = this.ie.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.Groups).InterfaceElements.sort((a, b) => a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);
    this.ieTabs = this.ieTabs.filter(tab => tab.Attributes.Visible ==  true);
    for(let ieTab of this.ieTabs){
      if(ieTab.Attributes.Active){
        this.activeTab = ieTab.InterfaceElementID;
      }
    }
    this.formGroup = this.ieTabs.find(element => element.Attributes.Enabled == true).InterfaceElementGroup;
  
    for(let tie of this.ieTabs){
      if(tie.InterfaceElements!= null){
        for(let tiee of tie.InterfaceElements){
          if(tiee.Attributes.Visible){
            if(this.ie.InterfaceElementGroup.controls[tiee.InterfaceElementID]!= null){
              if(this.ie.InterfaceElementGroup.controls[tiee.InterfaceElementID].status == 'DISABLED'){
                tie.InterfaceElementGroup.controls[tiee.InterfaceElementID].disable();
              }
              //tie.InterfaceElementGroup.controls[tiee.InterfaceElementID] = this.ie.InterfaceElementGroup.controls[tiee.InterfaceElementID];   
            }

            else if(this.ie.InterfaceElementGroup.controls[tiee.InterfaceElementID] == null){
              for(let piee of tie.InterfaceElements){
                if(piee.InterfaceElementID !== tiee.InterfaceElementID && this.ie.InterfaceElementGroup.controls[piee.InterfaceElementID]!= null){
                  setTimeout(() => {
                    if(this.ie.InterfaceElementGroup.controls[piee.InterfaceElementID].status == 'DISABLED'){
                      tie.InterfaceElementGroup.controls[tiee.InterfaceElementID].disable();
                    }  
                  }, 100);
                  break;
                }
              }
            }
          }
        }
      }
    }
  }

  updateGroupAssignments(ie:InterfaceElement){

    let toDeleteUnassignedIEs: any[] = [];
    let toDeleteAssignedIEs: {ieID: any, groupID: any}[] = [];
    let toDeleteShiftToUnAssignedIEs: {ieID: any, groupID: any}[] = [];
    let groups = this.ie.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.Groups).InterfaceElements;
      for(let iee of ie.InterfaceElements){
       if(iee.TypeDID!= InterfaceElementTypes.Groups && iee.Attributes.GroupID!= null){  
       for(let group of groups){
           if(group.InterfaceElementID == iee.Attributes.GroupID){
            delete iee.Attributes.GroupID;      
            group.InterfaceElements.push(iee);
            group.InterfaceElementGroup = this.cosyFormGroupValidationService.toFormGroup(group);
            toDeleteUnassignedIEs.push(iee.InterfaceElementID);
          }
        }
      }
      else if(iee.TypeDID == InterfaceElementTypes.Groups ){
        let reqGroupIndex : number = -1;
        for(let group of groups){
          for(let gie of group.InterfaceElements){
            if(gie.Attributes.GroupID!= null && gie.Attributes.GroupID != group.InterfaceElementID){
              reqGroupIndex = groups.map(function(e){return e.InterfaceElementID}).indexOf(gie.Attributes.GroupID);
              groups[reqGroupIndex].InterfaceElements.push(gie);
              groups[reqGroupIndex].InterfaceElementGroup = this.cosyFormGroupValidationService.toFormGroup(groups[reqGroupIndex]);
              toDeleteAssignedIEs.push({ieID: gie.InterfaceElementID, groupID: group.InterfaceElementID });
            }
            if(gie.Attributes.GroupID == null){
              ie.InterfaceElements.push(gie);
              toDeleteShiftToUnAssignedIEs.push({ieID: gie.InterfaceElementID, groupID: group.InterfaceElementID});
            }
          }
        }
      }
    }
    if(toDeleteUnassignedIEs.length>0){this.filterUnAssignedGroup(toDeleteUnassignedIEs, ie);}
    if(toDeleteAssignedIEs.length>0){this.filterFromPrevGroup(toDeleteAssignedIEs, groups);}
    if(toDeleteShiftToUnAssignedIEs.length>0){this.filterFromPrevGroup(toDeleteShiftToUnAssignedIEs, groups);}
    
  }

  filterUnAssignedGroup(toRemoveIDS, wizardIE: InterfaceElement){
    for(let tr of toRemoveIDS){
      let removeUnassignedIndex = wizardIE.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(tr);
      wizardIE.InterfaceElements.splice(removeUnassignedIndex,1);
    }
  }
  filterFromPrevGroup(toRemoveData: {ieID:any, groupID:any}[], wizardGroups){
     for(let group of wizardGroups){
       for(let trd of toRemoveData){
         if(trd.groupID == group.InterfaceElementID){
           let toRemoveDataIndex = group.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(trd.ieID);
           if(toRemoveDataIndex>-1){
            group.InterfaceElements.splice(toRemoveDataIndex, 1);
           }
         }
       }
     }
  }
  
  showNdownloadPDF(ieDocID: string, value: any, type) {
    this.cosyCommunicationControllerService.showNdownloadPDF(value).subscribe((res: any) => {
      this.pdfBase64 = res['b64Data'];
      const linkSource = 'data:application/pdf;base64,' + res['b64Data'];
      this.pdfURL = this.base64ToArrayBuffer(res['b64Data']);
      let blob = new Blob([this.pdfURL], { type: 'application/pdf' });
      if (type == 'download') {
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = res['fileName'];
        link.click();
      } else if (type == 'show') {
        var displayValue = document.getElementById(ieDocID).style.display;
        if (displayValue == 'block') {
          document.getElementById(ieDocID).style.display = 'none';
        } else if (displayValue == 'none') {
          document.getElementById(ieDocID).style.display = 'block';
        }
      } else if (type == 'upload') {
        console.log('need to upload');
      }
    });
  }

  base64ToArrayBuffer(base64) {
    let binary_string = window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

}
